<r2e-logo [variant]="logoVariant()" />

<h1>
  <span>{{ 'AUTH.SIGN_IN.TITLE' | translate }}</span>
  {{ 'AUTH.SIGN_IN.SUBTITLE' | translate }}
</h1>

<form [formGroup]="signInForm" (ngSubmit)="signIn()">
  <div class="form-field">
    <label for="email">{{ 'COMMON.LABELS.EMAIL' | translate }}</label>
    <input formControlName="email" id="email" type="email">
    <span class="error" *r2eValidationError="let errorMessage from signInForm.controls.email.errors">{{ errorMessage }}</span>
  </div>

  <div class="form-field">
    <label for="password">{{ 'COMMON.LABELS.PASSWORD' | translate }}</label>
    <input formControlName="password" id="password" [type]="passwordHidden() ? 'password' : 'text'">
    <button mat-icon-button type="button" (click)="togglePasswordVisibility()">
      <mat-icon>{{ passwordHidden() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <span class="error" *r2eValidationError="let errorMessage from signInForm.controls.password.errors">{{ errorMessage }}</span>
  </div>

  <button type="submit">{{ 'AUTH.ACTIONS.SIGN_IN' | translate }}</button>
  <button mat-flat-button [disabled]="!signInForm.valid" type="button" (click)="signIn()">{{ 'AUTH.ACTIONS.SIGN_IN' | translate }}</button>
</form>

<r2e-sign-in-providers />

<footer>
  <div class="sign-up">
    {{ 'AUTH.SIGN_IN.LACK_OF_ACCOUNT_QUESTION' | translate }} <a routerLink="../sign-up">{{ 'AUTH.ACTIONS.SIGN_UP' | translate }}</a>
  </div>
</footer>
